import React from "react";
import {Button, Col, Image, Modal, Row, Skeleton} from "antd";
import useFetch from "hooks/fetch";
import {Project} from "interfaces";
import {CloseCircleOutlined, RightOutlined} from "@ant-design/icons";
import Lazyload from "react-lazyload";
import ReactGA from "react-ga";
import data from "./data";

const Portofolio : React.FC = () => {

    const [isLoading, datasource] = useFetch("project", "desc", true, 6);

    /**
     *
     * @param img
     * @param title
     * @param desc
     */
    const openModal = (img : string | undefined, title : string, desc : string) : void => {
        Modal.info({
            title         : null,
            icon          : null,
            width         : 500,
            closable      : true,
            centered      : false,
            closeIcon     : <CloseCircleOutlined style={{fontSize : 20, color : "#ffffff"}} />,
            okButtonProps : {style : { display : "none"}},
            style         : {padding : 0, overflow : "hidden"},
            bodyStyle     : {padding : 0},
            content       : (
                <div>
                    <Lazyload height={"100%"} once={true}>
                        <Image
                            width={"100%"}
                            src={img}
                            alt={title}
                            style={{ marginTop : "-8px", borderRadius : "5px 5px 0 0", cursor: "pointer"}}
                        />
                    </Lazyload>
                    <div style={{padding : "23px 20px"}}>
                        <h3>{title}</h3>
                        <hr style={{
                            width: "100px",
                            height: "6px",
                            background: "#3A3A3A",
                            borderRadius: "10px",
                            margin: "10px 0"
                        }}
                        />
                        <p>{desc}</p>
                    </div>
                </div>
            )
        })
    }

    return (
        <section id={"portofolio"} className={"main-portofolio"}>
            <div className={"public-container"}>
                <Row gutter={[50, 10]}>
                    <Col md={8} sm={24} xs={24}>
                        <div className={"section-heading"}>
                            <h2 className={"title"}>{data.portofolio.id.title}</h2>
                            <p className={"subtitle"}>{data.portofolio.id.subTitle}</p>
                        </div>
                        <div className={"portofolio-button"}>
                            <Button
                                href={"/project"}
                                type={"primary"}
                                size={"large"}
                                onClick={() => ReactGA.event({category : "Portofolio", action : "clicked", label : "view_more" })}
                            >
                                {data.portofolio.id.buttonText} <RightOutlined />
                            </Button>
                        </div>
                    </Col>
                    <Col md={16} sm={24} xs={24}>
                        <Row gutter={[20, 10]}>
                            {
                                (isLoading ? new Array(25).fill(1, 0, 6) : datasource)
                                    .map((item : Project, x) => (
                                        <Col key={x} lg={12} md={12} sm={24} xs={24}>
                                            <Lazyload height={1000} once={true}>
                                                <div
                                                    onClick={() => {
                                                        openModal(item?.image?.url, item.title, item.description);
                                                        ReactGA.event({category : "Portofolio", action : "clicked", label : "view_detail_" + item.title?.replace(/ /g, "_") })
                                                    }}
                                                    className={"portofolio-list"}
                                                >
                                                    <div className={"section-image"}>
                                                        {
                                                            isLoading
                                                                ? <Skeleton.Avatar size={500} shape={"square"} active={true} />
                                                                : <img
                                                                    width={"100%"} height={"100%"}
                                                                    style={{cursor : "pointer"}}
                                                                    src={item.image.url}
                                                                    alt={item.title}
                                                                />

                                                        }
                                                    </div>
                                                    <div className={"section-text"}>
                                                        <h3>{item.title}</h3>
                                                        <p>{
                                                            item.description?.length > 100
                                                                ? item.description.slice(0, 100) + " ..."
                                                                : item.description
                                                        }</p>
                                                    </div>
                                                </div>
                                            </Lazyload>
                                        </Col>
                                    ))
                            }
                        </Row>
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default React.memo(Portofolio);